import { render, staticRenderFns } from "./ModalMotivo.vue?vue&type=template&id=f66aea5a&scoped=true"
import script from "./ModalMotivo.vue?vue&type=script&lang=js"
export * from "./ModalMotivo.vue?vue&type=script&lang=js"
import style0 from "./ModalMotivo.vue?vue&type=style&index=0&id=f66aea5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66aea5a",
  null
  
)

export default component.exports